module.exports = {
  src: __webpack_public_path__ + "logo-trusted-db33dd3fecb5064d2890e5c0ed772b45.svg",
  width: 74,
  height: 74,
  bytes: 10429,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-trusted-db33dd3fecb5064d2890e5c0ed772b45.svg";
};